import styled from "styled-components";

import PageText from '../Text/PageText';

export const AccordionIcon = styled.div`
    position: absolute;
    top: 0;
    right: 15px;

    > img {
        height: 10px;

        :hover {
            cursor: pointer;
        }
    }
`;

export const GoalsAccordionTitleContainer = styled.div`
    position: relative;
`;

export const GoalsAccordionTitle = styled(PageText)`
    margin-right: 40px;
`;

export const GoalsBox = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    background-color: var(--white-concrete);
    border-radius: 10px;
    padding: 10px 15px;
`;